import React from "react";
import Sugar from "sugar";

import SearchResultList from "./SearchResultList";
import SearchResult from "./SearchResult";
import InlineScorecard from "../scorecard/InlineScorecard";

import Accordion from "./Accordion";

Sugar.extend();

function AccordionSearchResult({ source, data, highlight }) {

  return (
    <>
      <Accordion.Collapsed data={data}>
        <Accordion.SetCurrent data={data}>
          <SearchResult searchResult={data} highlight={highlight}/>
        </Accordion.SetCurrent>
      </Accordion.Collapsed>

      <Accordion.Expanded data={data}>
        <InlineScorecard source={source} data={data}>
          <Accordion.SetCurrent data={null}>
            <div className="navigation-link">
              &times; Done
            </div>
          </Accordion.SetCurrent>
        </InlineScorecard>
      </Accordion.Expanded>
    </>
  );
}



export default AccordionSearchResult;
